<template>
    <div>
        <div class="mb-4">
            <template v-if="course.registration_level === 'FREE'">
                <Collapse btn-class="btn-primary" body-class="mt-0">
                    <template v-slot:button>
                        Sessions
                    </template>
                    <div class="card border-0">
                        <SessionList
                            :course="course"
                            :sessions="course.sessions"
                        />
                    </div>
                </Collapse>
            </template>
            <template v-else-if="isSingle">
                <RegisterSingleSession
                    :course="course"
                    :session="course.sessions[0]"
                />
            </template>
            <template v-else>
                <RegisterMultipleSessions
                    :course="course"
                />
            </template>
        </div>

        <template v-for="(section, i) in course.sections">
            <Collapse
                :id="slug(section.title)"
                class="mb-3"
                :visible="isSectionExpanded(i, section)"
                :disabled="!course.has_collapsible_sections"
            >
                <template v-if="section.title" v-slot:button>
                    {{ section.title }}
                </template>

                <div class="bg-white p-3 p-print-0">
                    <div class="cursus-content" v-html="section.content"></div>
                </div>
            </Collapse>
        </template>
    </div>
</template>

<script>
    import { BModal } from 'bootstrap-vue';
    import Collapse from "../../ui/Collapse";
    import Icon from "../../ui/Icon";
    import SessionList from "../../SessionList";
    import RegisterSingleSession from "./RegisterSingleSession";
    import RegisterMultipleSessions from "./RegisterMultipleSessions";
    import { slug } from "../../../util";

    export default {
        components: {
            RegisterMultipleSessions,
            RegisterSingleSession,
            BModal,
            SessionList,
            Icon,
            Collapse,
        },
        props: {
            course: Object,
        },
        computed: {
            isSingle() {
                return this.course.sessions?.length === 1;
            },
        },
        methods: {
            slug,
            isSectionExpanded(i, section) {
                return i === 0 || !section.title;
            },
        },
    }
</script>
